module.exports = __webpack_public_path__ + "img/iconfeedback.afedc616.png";